module.exports = __webpack_public_path__ + "static/assets/d79b7cfa0e997d7247c9d5761d75ff3f.png";